import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Lightweight GA4 event delegation
try {
  const findTrackable = (node) => {
    let el = node;
    while (el && el !== document && el instanceof HTMLElement) {
      if (el.dataset && el.dataset.gtagEvent) return el;
      el = el.parentElement;
    }
    return null;
  };
  document.addEventListener('click', (e) => {
    const el = findTrackable(e.target);
    if (!el) return;
    const eventName = el.dataset.gtagEvent;
    const params = {};
    if (el.dataset.gtagCategory) params.category = el.dataset.gtagCategory;
    if (el.dataset.gtagLabel) params.label = el.dataset.gtagLabel;
    if (el.dataset.gtagValue) {
      const v = Number(el.dataset.gtagValue);
      if (!Number.isNaN(v)) params.value = v;
    }
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  }, { capture: true });
} catch(_) {}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
